<div class="main-page">
  <div class="main-wrapper">
    <div class="edit-profile">
      <div class="title flex" (click)="onBack()">
        <img
          src="assets/images/icons/left-arrow.svg"
          alt="Arrow Left Icon"
          *ngIf="!isDesktop"
        />
        <p>{{ isEditMode ? 'Edit Profile Info' : 'Profile Info' }}</p>

      </div>
      <div class="profile-info flex w-full" *ngIf="!isEditMode">
        <div class="w-full">
          <div class="profile-image">
            <img
              [src]="userProfile?.avatar || 'assets/images/icons/user-logo.png'"
              alt="User Avatar Image"
            />
          </div>
          <div class="user-details">
            <div class="info flex">
              <p>Full Name:</p>
              <p>{{ userProfile?.full_name || '-' }}</p>
            </div>
            <hr class="custom-hr" />
            <div class="info flex">
              <p>Phone Number:</p>
              <p>
                {{ userProfile?.phone_number ? '+' : ''
                }}{{ userProfile?.phone_number || '-' }}
              </p>
            </div>
            <hr class="custom-hr" />
            <div class="info flex">
              <p>Email:</p>
              <p>{{ userProfile?.email || '-' }}</p>
            </div>
          </div>
        </div>
        <div class="w-full action-buttons">
          <button
            class="button outline-warn-button flex w-full edit-button"
            (click)="logOut()"
            *ngIf="isDesktop"
          >
            <img src="assets/images/icons/logout-red.svg" alt="Logout Icon" />
            <span>Logout</span>
          </button>
          <button
            class="button primary-button flex edit-button w-full"
            (click)="isEditMode = true"
          >
            <img
              src="assets/images/icons/edit-line-white.svg"
              alt="Edit Icon"
            />
            Edit Profile
          </button>
        </div>
      </div>
      <div class="edit-user-profile flex" [class.hidden]="!isEditMode">
        <div class="edit-user-profile-details w-full">
          <div class="profile-image">
            <img
              [src]="userProfile?.avatar || 'assets/images/icons/user-logo.png'"
              alt="User Avatar Image"
            />
            <!-- =====MUST ADD EDIT LOGO AFTER FINAL DESIGN FOR EDIT PROFILE IMAGE=====
            <img
              class="edit-image-icon"
              src="assets/images/icons/edit-line.svg"
              alt="Edit Icon"
            /> -->
          </div>
          <form class="edit-user-form" [formGroup]="editForm">
            <div class="form-field">
              <input
                type="text"
                placeholder="Full Name"
                formControlName="first_name"
              />
              <img
                src="assets/images/icons/close-icon.svg"
                alt=""
                (click)="clearInputField('first_name')"
              />
            </div>
            <div class="flex phone-number-field-container">
              <div class="phone-number-field flex">
                <ng-container
                  *ngIf="userCountryDetail?.image && userProfile?.phone_number"
                >
                  <img [src]="userCountryDetail?.image" alt="" />
                  <span class="country-code">{{
                    userCountryDetail?.phone_prefix
                  }}</span>
                  <span class="upper-line"></span>
                  <span>{{ userProfile?.phone_number }}</span>
                </ng-container>
                <ng-container
                  *ngIf="
                    !userCountryDetail?.image || !userProfile?.phone_number
                  "
                >
                  <span>+1 xxxx xx xxx</span>
                </ng-container>
              </div>
              <p
                class="edit-number-button pointer"
                (click)="onEditPhoneNumber()"
              >
                {{ userProfile?.phone_number ? 'Edit Number' : 'Add Number' }}
              </p>
            </div>
            <div class="dashed-border" *ngIf="!userProfile.email"></div>
          </form>
          <ng-container *ngIf="!userProfile.email">
            <div id="recaptcha-wrapper" data-callback="callback"></div>
            <div class="flex action-buttons-wrapper">
              <div
                class="profile-item apple-login-wrapper w-full flex"
                *ngIf="!userProfile?.google_connect && !isGoogleConnected"
              >
                <button
                  class="google-button"
                  mat-flat-button
                  (click)="loginGoogleFirebase()"
                >
                  <img
                    src="assets/images/icons/google-login.svg"
                    alt="google"
                  />
                  <span>Connect with Google</span>
                </button>
              </div>
              <div class="hr-text">
                <span>or</span>
              </div>
              <div
                class="profile-item apple-login-wrapper"
                *ngIf="!userProfile?.apple_connect && !isAppleConnected"
              >
                <div
                  id="appleid-signin"
                  class="apple"
                  data-color="black"
                  data-border="true"
                  data-type="continue"
                  data-width="375px"
                  data-height="40px"
                ></div>
              </div>
            </div>
          </ng-container>
        </div>
        <button
          class="button primary-button w-full save-changes-button"
          type="button"
          (click)="onSubmit()"
          [class.disabled]="editForm.invalid"
        >
          Save Changes
        </button>
      </div>
      
    </div>
  </div>
</div>

<ng-template #editPhoneNumberDialog>
  <div class="edit-phone-container">
    <div class="header w-full flex">
      <h2>Edit Number</h2>
      <img
        src="assets/images/icons/close-icon.svg"
        alt=""
        (click)="closeDialogs()"
      />
    </div>
    <hr class="custom-hr" />
    <div class="detail w-full flex">
      <div class="tab-selector flex w-full">
        <div
          class="phone-tab flex"
          [class.active-tab]="editPhoneNumberActiveTab == 1"
        >
          <span class="circle"></span>
          <span>Enter Phone Number</span>
        </div>
        <div
          class="phone-tab flex"
          [class.active-tab]="editPhoneNumberActiveTab == 2"
        >
          <span class="circle"></span>
          <span>Verification Code</span>
        </div>
      </div>
      <app-sms-verification
        [isEditPhoneMode]="true"
        (isEditPhoneVerifyMode)="setEditPhoneActiveTab($event)"
      ></app-sms-verification>
    </div>
  </div>
</ng-template>
